import React from 'react';
import styles from './InputText.less';

class InputText extends React.Component {
	render() {
		const {className, refNode, ...props} = this.props;
		const {inputText: inputTextClass} = styles;
		const classes = [inputTextClass];

		if (className) {
			classes.push(className);
		}

		return (
			<input type='text' className={classes.join(' ')} ref={refNode} {...props} />
		);
	}
}

export default InputText;